import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setDescription as setLayoutDescription
} from '../redux/layouts'

export default function * requestChangeLayoutDescription (action) {
  const { id, description } = action.payload

  const optimisticAction = yield optimisticPut(setLayoutDescription({
    id,
    description
  }))

  try {
    yield call(apiAction, 'SetHomeLayoutDescription', {
      layoutId: id,
      description
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
